import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { CrmUserRecord, crmUserFromJSON } from "common/records/CrmUser";
import { fetch, receive, reset } from "common/reducers/Utils";
import { reducer as userReducer } from "common/reducers/user.reducer";
import { UserActions } from "common/reducers/user.actions";
import { IUserData } from "common/records/User";
import {
  CrmUserActions,
  FETCH_CRM_USER,
  RECEIVE_CRM_USER,
  RECEIVE_CRM_USERS,
  RESET_CRM_USER,
} from "common/reducers/crmUser.actions";

export const CrmUserStateRecord = Record({
  byId: Map<number, CrmUserRecord>(),
  lastSavedById: Map<number, CrmUserRecord>(),
});

export const initialState = CrmUserStateRecord();

export type CrmUserState = typeof initialState;

export const model = "crmUsers";
export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_CRM_USER:
      return fetch(state, model, crmUserFromJSON({ id: action.payload.id }));

    case RECEIVE_CRM_USER:
      const user = crmUserFromJSON({ ...action.payload });
      const userData = {
        id: user.user_id,
        first_name: user.user_first_name,
        email: user.user_email,
        last_name: user.user_last_name,
      } as IUserData;
      state = userReducer(state, UserActions.receiveUser(userData));
      return receive(state, model, user);

    case RECEIVE_CRM_USERS:
      action.payload.forEach((user) => {
        state = reducer(state, CrmUserActions.receiveCrmUser(user));
      });
      return state;

    case RESET_CRM_USER:
      if (!action.payload) return state;

      return reset(state, model, action.payload);

    default:
      return state;
  }
};
